export default "__VITE_ASSET__CyEaKLnk__"